import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom'
import { store } from './store'
import { history } from './lib/history'
import { logTiming } from '@/utils/timing'
import { warmAnalytics } from '@/lib/analytics'
import './index.css'
import App from './components/app/App/App.tsx'

logTiming('[boot] main.tsx evaluated')

createRoot(document.getElementById('root')!).render(
    <Provider store={store}>
        <HistoryRouter history={history as any}>
            <App />
        </HistoryRouter>
    </Provider>
)

// Load PostHog off the critical path — after first paint, when the browser is idle —
// so the analytics SDK never blocks the initial render. No-ops without VITE_POSTHOG_KEY.
const ric = (window as any).requestIdleCallback as undefined | ((cb: () => void) => void)
if (ric) ric(() => warmAnalytics())
else setTimeout(() => warmAnalytics(), 2000)